export default [
    {
        question: 'Where is Hilwa milk powder made?',
        answer: 'Hilwa milk powder is proudly made in New Zealand. We source high-quality milk from trusted New Zealand dairy farms known for their excellent farming practices. ',
    },
    {
        question: 'What makes Hilwa milk powder unique?',
        answer: 'Hilwa milk powder stands out for its commitment to quality and purity. We use only premium New Zealand milk, which is known for its nutritional value and taste. Our production process ensures that the milk is carefully processed and dried to retain its natural goodness, resulting in a rich and creamy milk powder.',
    },
    {
        question: ' Is Hilwa milk powder suitable for all ages?',
        answer: "Yes, Hilwa milk powder is suitable for all ages, from infants to adults. It is a versatile product that can be used as a daily dairy supplement or as a convenient option when fresh milk is not readily available. However, for specific recommendations regarding infant formula, it's always advisable to consult with a pediatrician.",
    },
   
    {
        question: 'Does Hilwa milk powder contain any additives or preservatives?',
        answer: 'No, Hilwa milk powder is free from additives and preservatives. We believe in providing a pure and natural product, and therefore, our milk powder does not contain any artificial colors, flavors, or preservatives. It is a wholesome dairy product that retains the essential nutrients naturally present in milk.',
    },

]